import { storage } from "@nuskin/ns-util";

export const IS_BROWSER = typeof window !== "undefined";

export const EXPIRE_TIME_MILLISECONDS = 2592000000; // 30 days in milliseconds

/**
 * Retrieves queryParam with strip off the extra ““ when we capture the utm / utt data from the url before passing this information
 */
export function stripOffExtraDoubleQuotes(value) {
  try {
    return value.replace(/(?:^")|(?:"$)/g, "");
  } catch (e) {
    console.log("Error in strip off the extra Double Quotes", e);
  }
}

/**
 * Sets the UTM information in the session storage.
 *
 * This function retrieves the UTM parameters from the current URL and stores them in the session storage under the key 'utmInfo'.
 * The UTM parameters are stored as an object, where the keys are the parameter names and the values are the corresponding parameter values.
 *
 */
export function setUTMInfo() {
  try {
    const utmInfo = {};

    if (IS_BROWSER) {
      const isFromUTM = location.search.includes("utm_");

      if (isFromUTM) {
        const cookieOption = {
          expires: new Date(Date.now() + EXPIRE_TIME_MILLISECONDS),
          secure: true,
          path: "/"
        };
        const queryParams = new URLSearchParams(location.search);
        queryParams.forEach((value, key) => {
          if (key.indexOf("utm_") > -1) {
            utmInfo[key] = stripOffExtraDoubleQuotes(value);
          }
        });
        storage.setItem(storage.metadata.UTM_INFO, utmInfo, cookieOption);
      }
    }
  } catch (e) {
    console.log("Error in setUTMInfo", e);
  }
}
